module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.showModal
    },
    attrs: {
      "id": "ra-modal"
    }
  }, [_c('div', {
    staticClass: "frame",
    class: {
      visible: _vm.isStepOne
    },
    attrs: {
      "id": "ra-modal-step1"
    }
  }, [_c('div', {
    staticClass: "close ra-modal-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('h2', [_vm._v("Get Updates")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "name": "firstName",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "name": "lastName",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone (optional)",
      "name": "phone",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-modal-confirm",
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [(!_vm.isLoadingConfirm) ? _c('span', [_vm._v("Confirm")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingConfirm) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "frame",
    class: {
      visible: !_vm.isStepOne
    },
    attrs: {
      "id": "ra-modal-step2"
    }
  }, [_c('div', {
    staticClass: "close ra-modal-close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://www.wwf.org.au/images/UserUploadedImages/389/WWF_Logo_CMYK-01.svg",
      "alt": "WWF Logo"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n      Your registration for "), _c('span', {
    attrs: {
      "id": "aa-modal-email2"
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" is\n      confirmed.\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-modal-back",
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Back to WWF\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Confirm your registration for "), _c('br'), _c('span', {
    attrs: {
      "id": "ra-modal-email1"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ece93e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!./~/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./src/components/newsletter/Details.vue
// module id = 664
// module chunks = 0